import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { Icon, Input, Button } from 'antd';
import FirstTimeLogin from './login/FirstTimeLogin';
import EmailVerification from './login/EmailVerification';
import authenticateUser from '../authentication/authenticateUser';
import createUserProfile from '../userFunctions/createUserProfile';
import getUserProfile from '../userFunctions/getUserProfile';
import retrieveUser from '../authentication/retrieveUser';
import zmailLogo from '../img/zmail_logo.png';
import loadingGif from '../img/loading.gif';
import constants from '../constants/appConstants';
import schoolConstants from '../constants/schoolConstants';
import store from '../reducers/store';
import ResetPassword from './ResetPassword';

import '../combinedStyles';
import userService from '../services/userService';
import positionsService from '../services/positionsService';
import conferenceService from '../services/conferenceService';
import locationService from '../services/locationService';
import statusService from '../services/statusService';

class Login extends Component {
  constructor(props) {
    super(props);

    var defaultUsername = localStorage.username ? localStorage.username : '';

    this.userService = userService;

    this.state = {
      username: defaultUsername,
      password: '',
      schoolName: 'zmailtest',
      firstTimeLogin: false,
      cognitoUser: null,
      loginStatus: null,
      loginStage: 'login',
      forgotPassword: false,
    };

    this.updateLoginStage = this.updateLoginStage.bind(this);
  }

  async componentWillMount() {
    await this.userService.isLoggedIn();
  }

  changeLoginStatus(status) {
    this.setState({
      loginStatus: status,
    });
  }

  handleKeyDown(event) {
    if (event.keyCode == 13) document.getElementById('loginBtn').click();
  }

  handleUsernameChange(event) {
    var newValue = event.target.value;
    localStorage.username = newValue;
    this.setState({ username: newValue });
  }

  handlePasswordChange(event) {
    var newValue = event.target.value;
    this.setState({ password: newValue });
  }

  handleSchoolNameChange(event) {
    var newValue = event.target.value;
    localStorage.zmailSchoolName = newValue;
    this.setState({ schoolName: newValue });
  }

  async handleLoginSubmit() {
    await this.onLoginSubmit(this.state.username, this.state.password, this.state.schoolName);
  }

  checkSchoolName(schoolName) {
    return constants.USER_SCHOOLS.indexOf(schoolName) > -1;
  }

  updateLoginStage(stage) {
    this.setState({ loginStage: stage });
  }

  handleNewPassword(val) {
    this.setState({
      password: val,
    });
  }

  async onLoginSubmit(username, password, schoolName) {
    if (username === '' || password === '') {
      this.changeLoginStatus('*Please enter your username and/or password');
    } else if (schoolName === '') {
      this.changeLoginStatus('*Please enter your school');
    } else if (!this.checkSchoolName(schoolName)) {
      this.changeLoginStatus('*Unrecognized school name');
    } else {
      this.changeLoginStatus(<Icon type='loading' />);

      try {
        const user = await this.userService.login(username, password);

        await this.handleLogin(user);
      } catch (e) {
        this.changeLoginStatus(e.message);
      }
    }
  }

  async handleLogin(responseData) {
    if (responseData.status === 200) {
      await positionsService.get();
      await conferenceService.getConferences();
      await locationService.getStates();
      await statusService.getStatuses();
      if (responseData.super_user) {
        await userService.getUsersFromOrg(window.localStorage.getItem('organization_id'));
      }

      store.dispatch({ type: 'UPDATE_ACTIVE_USER', activeUser: responseData });
      store.dispatch({ type: 'UPDATE_DISPLAYED_USER', displayedUser: responseData });
      store.dispatch({ type: 'UPDATE_FILTERS', filters: responseData.filters });
      store.dispatch({ type: 'UPDATE_ORG', organization: responseData.organization });

      this.props.history.push('/dashboard');
    } else if (responseData.status === 403) {
      this.setState({ loginStage: 'firstTimeLogin' });
    } else if (responseData.status === 400 || responseData.status === 404) {
      this.changeLoginStatus(responseData.message);
    }

    // switch on response code
    // if success, get user with filters. Set localStorage. push to dashboard
    // if user not found, throw error
    // If force change password, send to first time login page
  }

  handleForgotPassword() {
    this.setState({
      forgotPassword: true,
    });
  }

  render() {
    const { onLoginSubmit, onLoginFormChange, loading, error, name } = this.props;

    if (this.state.loginStage === 'firstTimeLogin') {
      return (
        <FirstTimeLogin
          history={this.props.history}
          username={this.state.username}
          handleNewPassword={this.handleNewPassword.bind(this)}
          updateLoginStage={this.updateLoginStage}
          cognitoUser={this.state.cognitoUser}
          schoolName={this.state.schoolName}
          oldPassword={this.state.password}
          email={this.state.username}
        />
      );
    } else if (this.state.forgotPassword) {
      return (
        <ResetPassword
          username={this.state.username}
          schoolName={this.state.schoolName}
          stage={'resetPassword'}
          history={this.props.history}
        />
      );
    }

    return (
      <div id='loginPage' className='loginPage' onKeyDown={this.handleKeyDown.bind(this)}>
        <img src={zmailLogo} className='loginLogo' alt='Zmail Logo' />
        <div className='loginDiv'>
          <Input
            prefix={<Icon type='user' style={{ fontSize: 13 }} />}
            placeholder='Username'
            onChange={this.handleUsernameChange.bind(this)}
            value={this.state.username}
          />
          <Input
            prefix={<Icon type='lock' style={{ fontSize: 13 }} />}
            type='password'
            placeholder='Password'
            onChange={this.handlePasswordChange.bind(this)}
            value={this.state.password}
          />
          <Button
            type='primary'
            htmlType='submit'
            className='loginButton'
            id='loginBtn'
            onClick={this.handleLoginSubmit.bind(this)}>
            Log in
          </Button>
          <br />
          <p className='loginStatus'>{this.state.loginStatus}</p>
          {localStorage.zmailSchoolName !== 'zmailtest' && (
            <p>
              If you are a Zcruit user, please log in{' '}
              <a href={`${process.env.ZCRUIT_BASE_URL}/dashboard`}>here</a>
            </p>
          )}
          <p className='loginMessage'>
            Forgot Password?{' '}
            <span className='recover-link' onClick={this.handleForgotPassword.bind(this)}>
              Recover
            </span>
          </p>
        </div>
      </div>
    );
  }
}

function mapStoreToProps(storeState) {
  return {
    loggedIn: storeState.main.loggedIn,
    loadedCredentials: storeState.main.loadedCredentials,
  };
}

export default connect(mapStoreToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js